import axios, { type AxiosResponse } from 'axios'
//
const apiUrl = import.meta.env.VITE_API_URL

export default class FeedbackApi {
	route = 'feedback'

	async sendFeedback(params: { message: string }): Promise<AxiosResponse<{ message: string }>> {
		const res = await axios.post(`${apiUrl}/${this.route}`, params)
		return res
	}
}
